import {
  NodeType,
  OutputType,
  type MapNode,
  type NodeOutputData,
} from 'common/src/modules/nodes/nodes.types';
import {ConditionCategory} from 'common/src/modules/conditions/conditions.types';
import {cardTypeToName} from '../../../../campaignSetupAgent.config';

export function getBaseHeader(card: MapNode): string {
  const typeName = cardTypeToName[card.type as NodeType] ?? 'Card';

  return `Card Id: ${card.id}
Name: ${card.name || `${typeName} card`}
Type: ${typeName}`;
}

export function getOutputIdentifier(output: {name?: string | number | null; id: number}): string {
  const namePart = output.name ? ` '${output.name}'` : '';

  return `${output.id}${namePart}`;
}

export function getDestinationPhrase(nodeId: number): string {
  return nodeId ? `leads to card ${nodeId}` : "doesn't lead anywhere";
}

export function getOutputTypePhrase(output: NodeOutputData): string {
  switch (output.type) {
    case OutputType.Regular:
      return '(selection succeeded)';
    case OutputType.Fallback:
      return '(selection failed)';
    case OutputType.Last:
      return '(last output)';
    case OutputType.PartialSuccess:
      return '(partial success, not enough products selected)';
    default:
      return '(selection failed)';
  }
}

export function getCategoryUINamePart(signalMainCategory?: ConditionCategory): string {
  if (signalMainCategory == null) {
    return '';
  }

  const categoryName = ConditionCategory[signalMainCategory];

  return categoryName ? `${categoryName} ` : '';
}
